import React from 'react';
import { observer, inject } from 'mobx-react';
import { injectIntl } from 'react-intl';
import {
  Button,
  FormGroup,
  ControlLabel,
  ButtonToolbar
} from 'react-bootstrap';
import TextareaAutosize from 'react-autosize-textarea';
import Select from 'react-select-plus';
import 'react-select-plus/dist/react-select-plus.css';

@injectIntl
@inject('rootStore', 'valuePropositionsStore', 'tasksStore')
@observer
export default class NewTaskForm extends React.Component {
  constructor(props) {
    super(props);
    const initialText = props.feedbackChain.description;
    this.state = {
      title: '#' + props.feedbackChain.id + ': ' + props.feedbackChain.title,
      text: initialText,
      selectedVpElement: undefined
    };
  }

  render() {
    const {
      intl,
      feedbackChain,
      valuePropositionsStore,
      tasksStore
    } = this.props;
    const showSave =
      this.state.text &&
      this.state.text.length > 0 &&
      this.state.selectedVpElement;
    if (tasksStore.loading || feedbackChain.updating) {
      return (
        <div className="text-center">
          <div className="main-loader">
            <div className="loader-lg"></div>
          </div>
          <span>{intl.formatMessage({ id: 'tasks_toolbar_loading' })}</span>
        </div>
      );
    }

    return (
      <div className="new-task-form">
        <FormGroup controlId="new-task-form">
          <ControlLabel>
            {intl.formatMessage({ id: 'mvp_feature_select_label' })}
          </ControlLabel>
          <div>
            <Select
              options={valuePropositionsStore.selectableMvpsBoards(
                feedbackChain.valuePropositionId
              )}
              value={this.state.selectedVpElement}
              onChange={el => this.setState({ selectedVpElement: el })}
              placeholder={intl.formatMessage({
                id: 'vp_element_select_placeholder'
              })}
              clearable={false}
            />
          </div>
          <br />

          <ControlLabel>
            {intl.formatMessage({ id: 'new_task_title_label' })}
          </ControlLabel>
          <TextareaAutosize
            className="editable-text-area form-control"
            value={this.state.title}
            placeholder={intl.formatMessage({
              id: 'new_task_title_placeholder'
            })}
            onChange={this.handleTitleChange}
            rows={1}
          />

          <ControlLabel>
            {intl.formatMessage({ id: 'new_task_description_label' })}
          </ControlLabel>
          <TextareaAutosize
            className="editable-text-area form-control"
            value={this.state.text}
            placeholder={intl.formatMessage({
              id: 'new_task_description_placeholder'
            })}
            onChange={this.handleTextChange}
            rows={3}
          />

          <div>
            <ButtonToolbar>
              <Button
                className={'pull-right'}
                bsStyle={'primary'}
                onClick={this.handleAdd}
                disabled={!showSave}
              >
                {intl.formatMessage({ id: 'add_task_button' })}
              </Button>
              <Button
                className={'pull-right'}
                bsStyle={'default'}
                onClick={this.props.onCancel}
              >
                {intl.formatMessage({ id: 'cancel' })}
              </Button>
            </ButtonToolbar>
          </div>
        </FormGroup>
      </div>
    );
  }

  handleTitleChange = e => {
    this.setState({
      title: e.target.value
    });
  };

  handleTextChange = e => {
    this.setState({
      text: e.target.value
    });
  };

  handleAdd = () => {
    this.props.tasksStore.create(
      this.state.title,
      this.state.text,
      this.state.selectedVpElement.value.toDoListId,
      this.props.feedbackChain
    );
  };
}
